import {
  FETCH_RAV2_CIC_SUCCESS,
} from './actions';
import { Map } from 'immutable';
import RAv2Cic from './model';

export default function rav2Cic(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_RAV2_CIC_SUCCESS: {
      if (! action.payload) {
        return state.set(action.sessionId, null);
      }
      return state.set(action.sessionId, RAv2Cic.create(action.payload));
    }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./data/RAv2Cic/reducer.js